import { getEventDesktop } from "app/api/eventsApi";
import * as FavouriteAPI from "app/api/favouritesApi";
import store from "app/store/store";
//
export class FavouritesHelper {
  static updateFavourite: any = (eventId: number, favouritesOnly: boolean) => {
    // since web socket update not avaiable use AJAX call
    getEventDesktop(eventId, true)
      .then(eventData => {
        store.dispatch.competitionListModel.updateEventFavouriteInCompetitionInList(
          eventData,
          favouritesOnly
        );
        // get latest favourites from API
        FavouriteAPI.getFavouriteList();
      })
      .catch(error => {
        throw error;
      });
  };
}
